<h1>Übertragung der Online-Plattform BIMSWARM.online an die BIMSWARM GmbH</h1>

<section class="first-block">
    <p>
        Als Nutzer der <b>bimswarm.online-Plattform</b> (<a href="https://bimswarm.online"
            target="_blank">https://bimswarm.online</a>)
        möchten wir Sie über eine anstehende Umstrukturierung informieren: Ab
        dem 26.11.2025 wird die
    </p>

    <blockquote>
        <p><b>BIMSWARM GmbH</b></p>
        <p>Geneststraße 5</p>
        <p>10829 Berlin</p>
        <p>vertreten durch den Geschäftsführer Herrn Dr. Jan Tulke</p>
    </blockquote>

    <p>
        neue Betreiberin der <b>bimswarm.online-Plattform.</b> Die
        bimswarm.online-Plattform begibt sich damit in ein neues Umfeld. Die
        BIMSWARM GmbH wurde für die Weiterentwicklung von BIMSWARM als
        Tochtergesellschaft der planen-bauen 4.0 Gesellschaft zur
        Digitalisierung des Planens, Bauens und Betreibens mbH gegründet. Wir
        haben mit der BIMSWARM GmbH die Übernahme und Fortführung des
        Geschäftsbetriebs betreffend die bimswarm.online-Plattform
        einschließlich der Vertragsbeziehung mit Ihrem Unternehmen vereinbart.
        Das bedeutet, dass wir alle mit Ihnen bestehenden Verträge und etwaige
        damit verbundene Forderungen und Verbindlichkeiten zu den bisherigen
        Konditionen und unter Entlassung des bisherigen Vertragspartners aus
        dieser Position übernehmen. Bitte bestätigen Sie die Übertragung der
        bestehenden Verträge zwischen Ihnen und der planen-bauen 4.0
        Gesellschaft zur Digitalisierung des Planens, Bauens und Betreibens mbH
        von der planen-bauen 4.0 Gesellschaft zur Digitalisierung des Planens,
        Bauens und Betreibens mbH auf uns unter Entlassung der planen-bauen 4.0
        Gesellschaft zur Digitalisierung des Planens, Bauens und Betreibens mbH
        aus ihrer Rolle als Vertragspartner, Schuldner und/oder Gläubiger durch
        Bestätigung der Checkbox
    </p>

    <p class="highlight">
        <em>„Ich stimme der Übertragung meines bestehenden Vertrages wie hier
            beschrieben zu"</em>
    </p>

    <p>im Rahmen des Registrierungsprozesses.</p>

    <p>
        Zum Zwecke der Fortführung Ihres Nutzungsvertrags werden wir die uns
        vorliegenden personenbezogenen Daten von Ihnen, soweit erforderlich, an
        die BIMSWARM GmbH übertragen. Dazu gehören auch Ihre Inhalte, die Sie
        auf der Online-Plattform gespeichert haben. Sie finden dazu im
        <b>Anhang</b> entsprechende <b>Datenschutzhinweise</b>.
    </p>

    <p class="important">
        <b>In datenschutzrechtlicher Hinsicht können Sie der Übertragung Ihrer
            Daten an die BIMSWARM GmbH innerhalb von 30 Tagen nach Ihrer Bestätigung
            des Vertragsübergangs widersprechen. Bitte richten Sie diesen
            Widerspruch an uns (Geneststraße 5, 10829 Berlin, info&#64;planen-bauen40.de).
            Bitte beachten Sie jedoch, dass wir in diesem Fall leider gezwungen
            sind, den Nutzungsvertrag mit Ihnen mit Wirkung zum oben genannten Datum
            zu beenden. Sie haben bis zum oben genannten Datum die Möglichkeit, Ihre
            Daten über Ihre Profilseite herunterzuladen.</b>
    </p>

    <p>
        Wir freuen uns auf die künftige Zusammenarbeit. Bei etwaigen Fragen
        zögern Sie bitte nicht, uns anzusprechen unter
        customersuccess&#64;bimswarm.de.
    </p>

    <p>Mit freundlichen Grüßen</p>
    <p>Ihr BIMSWARM Team</p>
    <br>

    <p>Dr. Jan Tulke</p>
    <p>Geschäftsführer</p>
</section>

<section>
    <h2>Datenschutzhinweise Kundenmigration</h2>

    <h3>1. Datenschutzrechtliche Verantwortlichkeit und Datenschutzbeauftragter</h3>
    <div class="block-content">
        <p><b>Verantwortliche für die Datenübermittlung</b></p>

        <blockquote>
            <p>planen-bauen 4.0 - Gesellschaft zur Digitalisierung des Planens,
                Bauens und Betreibens mbH</p>
            <p>Geschäftsführer Dr. Jan Tulke</p>
            <p>Geneststraße 5</p>
            <p>10829 Berlin</p>
            <p>+49 30 22 45 20 40</p>
            <p>info&#64;planen-bauen40.de</p>
        </blockquote>

        <p><b>Datenschutzbeauftragter</b></p>

        <blockquote>
            <p>Christian Tomaske</p>
            <p>Telefon: +49 (0) 171 380 47 73</p>
            <p>E-Mail: ct&#64;ratio42.de</p>
        </blockquote>
    </div>

    <h3>2. Personenbezogene Daten</h3>
    <div class="block-content">
        <ul>
            <li class="li-list">Name und Nutzerkennung</li>
            <li class="li-list">(geschäftliche) Postadresse (falls vorhanden)</li>
            <li class="li-list">(geschäftliche) Telefonnummer und E-Mail-Adresse (falls vorhanden)</li>
            <li class="li-list">Nutzerprofil</li>
            <li class="li-list">Nutzerinhalte</li>
        </ul>
    </div>

    <h3>3. Zweck der Datenverarbeitung, Empfänger Ihrer personenbezogenen Daten und Rechtsgrundlage</h3>
    <div class="block-content">
        <p>
            Wir verarbeiten Ihre personenbezogenen Daten, um sie an die BIMSWARM
            GmbH, Geneststraße 5, 10829 Berlin, zu übermitteln. Ihre
            personenbezogenen Daten werden von uns an die BIMSWARM GmbH migriert.
        </p>

        <p>
            Diese Datenübermittlung erfolgt aufgrund unseres berechtigten
            Interesses. Die BIMSWARM GmbH übernimmt den Betrieb der
            bimswarm.online-Plattform. Wir führen die <b>bimswarm.online-Plattform</b>
            nicht mehr fort.
        </p>

        <p>
            Im Rahmen der erforderlichen Interessenabwägungen haben wir Ihr
            Vertraulichkeitsinteresse und unsere Interessen an der Datenübermittlung
            jeweils miteinander abgewogen. Ihr Vertraulichkeitsinteresse tritt dabei
            zurück. Wir könnten andernfalls nicht sicherstellen, dass sie weiterhin
            die bimswarm.online-Plattform nutzen können.
        </p>
    </div>

    <h3>4. Speicherdauer</h3>
    <div class="block-content">
        <p>
            Wir löschen Ihre personenbezogenen Daten, wenn der jeweilige Zweck der
            Speicherung entfällt und keine gesetzliche Vorschrift eine weitere
            Aufbewahrung erfordert.
        </p>
    </div>

    <h3>5. Ihre Betroffenenrechte</h3>
    <div class="block-content">
        <p>
            Bitten wenden Sie sich für die Wahrnehmung Ihrer Rechte an unsere o.g.
            Kontaktdaten. Sie haben nach der DSGVO folgende Betroffenenrechte:
        </p>

        <ul>
            <li>
                <b>Recht auf Auskunft</b>: Unter den Voraussetzungen des Art. 15 DSGVO
                können Sie jederzeit Auskunft über Ihre von uns verarbeiteten
                personenbezogenen Daten sowie eine Kopie Ihrer Daten verlangen.
            </li>
            <li>
                <b>Recht auf Berichtigung</b>: Unter den Voraussetzungen des Art. 16
                DSGVO können Sie unverzüglich die Berichtigung unrichtiger oder
                Vervollständigung unvollständiger Daten zu Ihrer Person verlangen.
            </li>
            <li>
                <b>Recht auf Löschung</b>: Darüber hinaus können Sie unter den
                Voraussetzungen des Art. 17 DSGVO die Löschung Ihrer bei uns
                gespeicherten personenbezogenen Daten verlangen.
            </li>
            <li>
                <b>Recht auf Einschränkung der Verarbeitung</b>: Nach Maßgabe von Art.
                18 DSGVO können Sie ferner die Einschränkung der Verarbeitung
                Ihrer personenbezogenen Daten verlangen.
            </li>
            <li>
                <b>Recht auf Auskunft über Empfänger</b>: Nach Art. 19 DSGVO haben Sie
                das Recht Auskunft über die Empfänger von Daten zu verlangen,
                denen eine Berichtigung, Löschung Ihrer personenbezogenen Daten
                oder eine Einschränkung der Verarbeitung mitgeteilt wurde.
            </li>
            <li>
                <b>Recht auf Datenübertragbarkeit</b>: Unter den Voraussetzungen des
                Art. 20 DSGVO haben Sie das Recht, Ihre personenbezogenen Daten in
                einem strukturierten, gängigen und maschinenlesbaren Format zu
                erhalten oder die Übermittlung unmittelbar an einen anderen
                Verantwortlichen zu verlangen.
            </li>
            <li>
                <b>Widerrufsrecht</b>: Sollten wir personenbezogene Daten aufgrund
                einer Ihrerseits erteilten Einwilligung verarbeiten, sind Sie
                zudem berechtigt, Ihre Einwilligung gemäß Art. 7 Abs. 3 DSGVO
                jederzeit zu widerrufen. Ihr Widerruf hat zur Folge, dass wir die
                Datenverarbeitung, die bis dahin auf dieser Einwilligung beruht,
                für die Zukunft nicht mehr fortführen. Die Rechtmäßigkeit der
                aufgrund Ihrer Einwilligung bis zum Widerruf erfolgten
                Verarbeitung bleibt von Ihrem Widerruf unberührt.
            </li>
            <li>
                <b>Beschwerderecht</b>: Sofern Sie der Auffassung sind, dass die
                Verarbeitung der Sie betreffenden personenbezogenen Daten durch uns
                gegen datenschutzrechtliche Bestimmungen verstößt, steht Ihnen das
                Recht auf Beschwerde bei einer Aufsichtsbehörde nach Art. 77 DSGVO
                zu. In Berlin ist der Berliner Beauftragte für Datenschutz und
                Informationsfreiheit (BInBDI) die zuständige Aufsichtsbehörde
                (Friedrichstr. 219, 10969 Berlin, <a
                    href="mailto:mailbox@datenschutz-berlin.de">mailbox&#64;datenschutz-berlin.de</a>).
            </li>
        </ul>

        <p class="important">
            <b>WIDERSPRUCHSRECHT</b>: UNTER DEN VORAUSSETZUNGEN DES ART. 21 DSGVO HABEN
            SIE ZUDEM DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN
            SITUATION ERGEBEN, JEDERZEIT DER VERARBEITUNG IHRER PERSONENBEZOGENEN
            DATEN ZU WIDERSPRECHEN, SOFERN DIE VERARBEITUNG AUF EINEM BERECHTIGTEN
            INTERESSE GEMÄSS ART. 6 ABS. 1 S. 1 LIT. F DSGVO ODER AUF ART. 6 ABS. 1
            S. 1 LIT. E DSGVO BERUHT (DIES GILT AUCH FÜR EIN AUF DIESE BESTIMMUNGEN
            GESTÜTZTES PROFILING.). WIR WERDEN DIE VERARBEITUNG IHRER
            PERSONENBEZOGENEN DATEN EINSTELLEN, ES SEI DENN, WIR KÖNNEN ZWINGENDE
            SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG NACHWEISEN, DIE IHRE
            INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN, ODER WENN DIE VERARBEITUNG
            DER GELTENDMACHUNG, AUSÜBUNG ODER VERTEIDIGUNG VON RECHTSANSPRÜCHEN
            DIENT.
            <br>
            <br>
            <b>EINLEGUNG DES WIDERSPRUCHS</b>: DER WIDERSPRUCH KANN FORMLOS PER POST
            ODER E-MAIL ERKLÄRT WERDEN.
        </p>

        <p>
            Weitere Informationen zum Datenschutz bei BIMSWARM finden Sie in unseren
            Datenschutzhinweisen unter: <a href="https://bimswarm.online/privacy"
                target="_blank">https://bimswarm.online/privacy</a>.
        </p>
    </div>
</section>

<div mat-dialog-actions>
    <button mat-button (click)="onClick(false)" class="btn_red" cdkFocusInitial>
        {{ data.buttonNo }}
    </button>
</div>